const component = 'press-release-autoplay';

if (!customElements.get(component)) {
  class PressReleaseAutoplay extends HTMLElement {
    constructor() {
      super();

      this.initSliderHandler = $(this.querySelector('.js-init-slider'));
    }

    initSlider() {
      $(this.initSliderHandler).slick({
        infinite: true,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        autoplay: this.dataset.autoplay === 'true' ? true : false,
        autoplaySpeed: +this.dataset.autoplaySpeed * 1000,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              variableWidth: true,
            }
          },
        ],
      });
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.querySelector('.js-init-slider').slick('destroy');
    }
  }

  customElements.define(component, PressReleaseAutoplay)
}
